module.exports = __webpack_public_path__ + "static/media/volunteer.7e81d626.png";